(ns pfo.core
  (:require [dommy.core :as dommy :refer-macros [sel sel1]]
            [cljs-time.core :as time-core]
            [promesa.core :as p]
            [reagent.core :as reagent :refer [atom]]
            [reagent.dom :as reagent-dom]
            [reagent.session :as session]
            [secretary.core :as secretary :include-macros true]
            [goog.events :as events]
            [goog.history.EventType :as EventType]
            [goog.string :refer [contains]]
            [malli.instrument :as mi]
            [pfo.flash :refer [set-flash flash]]
            [pfo.common.component :refer [empty-page]]
            [pfo.util :as util]
            [pfo.test]
            [pfo.auth :as auth]
            [pfo.auth.model :refer [perm has-perm validate-reset-request]]
            [pfo.api :as api :refer [process-error]]
            [pfo.component :refer [page]]
            [pfo.valid :as valid]
            [pfo.collection.core]
            [pfo.collection.model :as collection-model]
            [pfo.document.core]
            [pfo.task.component]
            [pfo.dashboard.component :as dashboard]
            ;; [pfo.task.core]
            [pfo.admin.core]
            [pfo.search.core]
            [pfo.category.core]
            [pfo.weblink.core]
            [pfo.state :as state]
            [pfo.infobox :refer [infobox-hide]]
            [pfo.admin.component :as admin]
            [bidi.bidi :as bidi]
            [pfo.routes :as routes]
            [pfo.im.component :as im-component]
            [taoensso.timbre :as timbre])
    (:import goog.History))

(secretary/set-config! :prefix "#")

(secretary/defroute "/" []
  (when (has-perm :can_view_dashboard) (util/set-page dashboard/dashboard)))

(secretary/defroute "/password-reset-init/" []
  (api/set-auth-info :auth-state :password-reset-init))

(secretary/defroute "/password-reset/:token/" [token]
  (->> (validate-reset-request token)
       (p/map (fn [response]
                (if (:valid response)
                  (->> (auth/login-with-token {:success-state :password-reset 
                                               :skip-path-restore true} token)
                       (p/map (fn [_]
                                (api/set-auth-info :password-reset-token token)))
                       (p/error (fn [err]
                                  (if (= 401 (:status err))
                                    (set-flash :error "Your password reset request is no longer valid, try resetting the password again.")
                                    (throw err))))
                       (process-error))
                  (set-flash :error "Your password reset request is no longer valid, try resetting the password again."))))) 
  (util/set-initial-page empty-page))

(secretary/defroute "/setpassword/:token/" [token]
  (let [message "Your link is no longer valid, please click \"Forgot your password?\" on the login page to set your password or contact the administrator."]
    (->> (validate-reset-request token)
         (p/map (fn [{valid :valid}]
                  (if valid
                    (->> (auth/login-with-token {:success-state :preauth
                                                 :skip-path-restore true} token)
                         (p/map (fn [_]
                                  (util/set-page (partial admin/user-password-reset-form token))))
                         (p/error (fn [err]
                                    (if (= 401 (:status err))
                                      (set-flash :error message)
                                      (throw err))))
                         (process-error))
                    (set-flash :error message)))))
    (util/set-initial-page empty-page)))

(add-watch session/state "infobox-watcher" #(infobox-hide))

(declare mount-root)
(defonce history (History.))
(secretary/defroute "/logout" []
  (im-component/reset-state!)
  (api/set-auth-info :data nil)
  (api/set-auth-info :auth-state :logged-out)
  (secretary/dispatch! "/")
  (.setToken history "/"))

(defn hook-browser-navigation! []
  (doto history
    (events/listen
      EventType/NAVIGATE
      (fn [event]
        (if-let [[tag-name handler] (routes/get-handler (.-token event))]
          (do (swap! state/nav-flow state/add-nav-flow {:location (.-token event) :time (time-core/now)})
              (reset! state/last-nav-tag-name tag-name)
              (handler))
          (do (swap! state/nav-flow state/add-nav-flow {:location (.-token event)
                                                        :time (time-core/now)})
              (reset! state/last-nav-tag-name nil)
              (secretary/dispatch! (.-token event))))))
    (.setEnabled true)))

(defn mount-root []
  (try
    (reagent-dom/render [auth/force-login state/current-page page] (.getElementById js/document "app"))
    (catch :default e
      (timbre/info "Error occurred" e))))

(defn init! []
  (when (sel1 :#app)
    (timbre/info "Loading iPaladin...")
    (hook-browser-navigation!)
    (mount-root)
    (timbre/info "Done loading iPaladin.")
    (when js/DEMO_MODE
      (auth/login-demo nil))))
(goog-define log-level "info")

(defn setup-and-init []
  (set! js/Promise p/Promise)
  (timbre/set-min-level! (keyword log-level))
  (timbre/report "Log level set to" log-level)
  (init!))

(defn ^:dev/before-load stop [])

(defn ^:dev/after-load start []
  (setup-and-init))
